import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  optout() {
    this._changeAllAndHide(false)
  }

  accept() {
    this._changeAllAndHide(true)
  }

  _changeAllAndHide(acceptAll) {
    let cookies = { product_analytics_cookies: acceptAll, advertising_cookies: acceptAll }

    fetch("/users/update-cookies", {
      method: "PATCH",
      headers: new Headers({
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content")
      }),
      credentials: "same-origin",
      body: JSON.stringify(cookies),
      redirect: "manual",
    }).then((response) => {
      response.json().then((data) => {
        if (data.cookies_changed) {
          window.location.reload()
        } else {
          this.element.classList.add("d-none")
        }
      })
    })
  }
}
